import { GetCountryDetails } from '@/utils/helpers.js'
export default {
  data () {
    return {}
  },
  computed: {
    country () {
      const activeCountry = this.$store.state.common.activeCountry
      const details = GetCountryDetails(activeCountry)
      return details
    },
    country2 () {
      const secondaryCountry = this.$store.state.common.secondaryCountry
      const details = GetCountryDetails(secondaryCountry)
      return details
    }
  }
}
